//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    leftAlign: {
      type: Boolean,
      default: false
    }
  }
}
